import {
    SET_PRODUCT_TO_TRANSFER_CART, ADD_TO_TRANSFER_CART, SET_QUANTITY_TO_TRANSFER_CART,
    ADD_TO_PENDING_ORDERS, GET_PENDING_ORDER_BY_ID, GET_CONSOLIDATE_PRODUCTS,
    GET_PENDING_ORDERS, CLEAR_PENDING_ORDERS, CLEAR_TRANSFER_CART, ADD_SPECIFICATION,
    CLEAR_SPECIFICATION, CLEAR_SPECIFICATION_DEVOLUTION, ADD_SPECIFICATION_DEVOLUTION,
    IS_LOADING_BESTSELLER_PRODUCTS, GET_BESTSELLER_PRODUCTS
} from '../actions/types'

const initialState = {
    isLoadingBestSellerProducts: false,
    bestSellerProducts: [],
    consolidateProducts: [],
    tranferCart: [],
    itemToTranfert: { consolidateProduct: null, quantity: 0 },
    productBatches: [],
    pendingOrder: [],
    pendingOrders: [],
    specifications: [],
    specificationsDevolutions: [],
    devolutions: [],
    devolutionsDetail: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case "GET_DEVOLUTIONS_DETAILL":
            return { ...state, devolutionsDetail: action.payload }
        case "GET_DEVOLUTIONS":
            return { ...state, devolutions: action.payload }

        case SET_PRODUCT_TO_TRANSFER_CART:
            return { ...state, itemToTranfert: { ...state.itemToTranfert, consolidateProduct: action.payload } }
        case SET_QUANTITY_TO_TRANSFER_CART:
            return { ...state, itemToTranfert: { ...state.itemToTranfert, quantity: action.payload } }
        case ADD_TO_TRANSFER_CART:
            var tranferCart = state.tranferCart

            if (tranferCart.find(item => item.product.productId._id === action.payload.product.productId._id)) {
                tranferCart.map((item) => {
                    if (item.product.productId._id === action.payload.product.productId._id) {
                        item.quantity = action.payload.quantity
                    }
                })
            } else {
                tranferCart.push({ product: action.payload.product, quantity: action.payload.quantity })
            }

            // localStorage().setItem("shoppingBag", JSON.stringify(tranferCart))
            return { ...state, tranferCart: tranferCart }
        case CLEAR_TRANSFER_CART:
            return { ...state, tranferCart: [] }
        case ADD_TO_PENDING_ORDERS:
            var pendingOrders = state.pendingOrders
            pendingOrders.push(action.payload)
            return { ...state, pendingOrders: pendingOrders }
        case GET_PENDING_ORDER_BY_ID:
            const pendingOrder = action.payload
            return { ...state, pendingOrder: pendingOrder }

        case IS_LOADING_BESTSELLER_PRODUCTS:
            return { ...state, isLoadingBestSellerProducts: true }

        case GET_BESTSELLER_PRODUCTS:
            return { ...state, isLoadingBestSellerProducts:false, bestSellerProducts: action.payload }

        case GET_CONSOLIDATE_PRODUCTS:
            return { ...state, consolidateProducts: action.payload }

        case GET_PENDING_ORDERS:
            return { ...state, pendingOrders: action.payload }
        case CLEAR_PENDING_ORDERS:
            return { ...state, pendingOrders: [] }
        case CLEAR_SPECIFICATION:
            return { ...state, specifications: [] }
        case ADD_SPECIFICATION:

            var specifications = state.specifications

            if (specifications.find(specification => specification.subOrderId === action.payload.subOrderId)) {
                specifications.map((specification) => {
                    if (specification.subOrderId === action.payload.subOrderId) {
                        specification.batches = action.payload.batches
                    }
                })
            } else {
                specifications.push(action.payload)
            }
            return { ...state, specifications: specifications }

        case CLEAR_SPECIFICATION_DEVOLUTION:
            return { ...state, specificationsDevolutions: [] }
        case ADD_SPECIFICATION_DEVOLUTION:

            var specifications = state.specificationsDevolutions

            if (specifications.find(specification => specification.productId === action.payload.productId)) {
                specifications.map((specification) => {
                    if (specification.productId === action.payload.productId) {
                        specification.batches = action.payload.batches
                    }
                })
            } else {
                specifications.push(action.payload)
            }
            return { ...state, specificationsDevolutions: specifications }
        default:
            return state

    }
}